// import  Basic  from 'layouts/authentication/sign-in/basic';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import React, { lazy, Suspense } from 'react';
import { LinearProgress } from '@mui/material';

const Illustration = lazy(() => import('layouts/authentication/sign-in/illustration'));
const Basic = lazy(() => import('layouts/authentication/sign-in/basic'));
const Cover = lazy(() => import('layouts/authentication/sign-in/cover'));

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const { login } = useAuth();

  useEffect(() => {
    if (localStorage.getItem('showSessionExpired') === 'true') {
      toast.error('Session expired.');
      localStorage.removeItem('showSessionExpired');
    }
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!email) {
      setEmailError('Email is required');
      return;
    }
    if (!password) {
      setPasswordError('Password is required');
      return;
    }

    try {
      await login(email, password);
      console.log('Login successful');
    } catch (error) {
      toast.error('Login failed');
    }
  };

  return (
    <Suspense fallback={<LinearProgress sx={{ width: '-webkit-fill-available' }} />}>
      <Cover />
    </Suspense>
  );
};

export default Login;
